<template>
  <v-toolbar-title>
    <v-icon :color="$vuetify.theme.dark ? '#647E98' : '#171717'">
      mdi-view-dashboard
    </v-icon>
    <span class="ml-4" v-if="isDashboard">Hello! {{ client?.fullname }}</span>
    <span class="ml-4" v-else>{{ currentPageTitle === 'Manage Investors Account Details' ? 'My Manager Account Details' : currentPageTitle === 'Bank Information' ? 'Wallet Information' : currentPageTitle === "Terms And Condition" ? "Terms & Conditions" : currentPageTitle === "Create Investor Account Auth" ? "Create Investor Account" : currentPageTitle === "Profile Verify" ? "Profile & Verification" : currentPageTitle }}</span>
  </v-toolbar-title>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapState } from "vuex";

export default {
  name: "DashboardView",
  data() {
    return {
      currentPageTitle: '',
      specialTitles: {
        'trading-account': 'Trading Account',
        'deposit': 'Deposit',
        'withdraw': 'Withdraw',
        'transaction-history': 'Transaction History',
        'profile': 'Profile Settings'
      },
      tabTitles: {
        '1': 'Overview',
        '2': 'Documents',
        '3': 'Trading Accounts',
        '4': 'Transactions'
      }
    };
  },
  computed: {
    ...mapState("profile", ["client"]),
    isDashboard() {
      return this.$route.path === '/dashboard';
    },
  },
  
  methods: {
    updatePageTitle() {
      if (!this.isDashboard) {
        const path = this.$route.path.split('/').pop();
        const queryParams = this.$route.query;
        this.currentPageTitle = this.getPageTitle(path, queryParams);
      }
    },
    getPageTitle(path, queryParams) {
      // Check if we have a tab parameter
      if (queryParams.tab && this.tabTitles[queryParams.tab]) {
        return `${this.specialTitles[path] || this.formatPageTitle(path)}`;
      }

      // If no tab parameter or unknown tab, use the special title or format the path
      return this.specialTitles[path] || this.formatPageTitle(path);
    },
    formatPageTitle(title) {
      // Handle kebab-case (e.g., "trading-account")
      if (title.includes('-')) {
        return title.split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      }

      // Handle camelCase or PascalCase (e.g., "tradingAccount")
      return title.replace(/([A-Z])/g, ' $1')
        .trim()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
  },
  async mounted() {
    try {
      this.updatePageTitle();
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  },
  watch: {
    $route() {
      this.updatePageTitle();
    },
  },
};
</script>